module.exports = __webpack_public_path__ + "static/media/pataks.ca7d3113.png";